module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video"
  }, [(!_vm.refreshPlayer) ? _c('youtube', {
    ref: "youtube",
    staticClass: "item",
    attrs: {
      "player-width": "100%",
      "player-height": "100%",
      "video-id": _vm.id,
      "mute": true,
      "player-vars": {
        autoplay: 1,
        start: _vm.start ? _vm.start : undefined,
        end: _vm.end ? (_vm.end + 2) : undefined,
        modestbranding: 1,
        iv_load_policy: 3
      }
    },
    on: {
      "playing": _vm.handlePlaying,
      "ready": function($event) {
        _vm.$emit('ready')
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80ed7b7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/Dashboard/components/Player.vue
// module id = 721
// module chunks = 1